import { create } from 'zustand';
import type { ConnectedAnalyzeRequest } from './types';

interface State {
  request: ConnectedAnalyzeRequest;
  setSection: (p: Partial<ConnectedAnalyzeRequest['section']>) => void;
  setMaterials: (p: Partial<ConnectedAnalyzeRequest['materials']>) => void;
  setSoil: (p: Partial<ConnectedAnalyzeRequest['soil']>) => void;
  setLoads: (p: Partial<ConnectedAnalyzeRequest['loads']>) => void;
  setReinforcement: (p: Partial<ConnectedAnalyzeRequest['reinforcement']>) => void;
  loadRequest: (req: ConnectedAnalyzeRequest) => void;
}

const defaultRequest: ConnectedAnalyzeRequest = {
  section: {
    Lx1: 150, Ly1: 200, Hf1: 60,
    bc1: 30, hc1: 30, x_col1: 15,
    Lx2: 200, Ly2: 200, Hf2: 60,
    bc2: 30, hc2: 30,
    bb: 30, hb: 60, L_cols: 500,
    df: 150,
  },
  materials: { fc: 210, fy: 4200, cover: 7.5, cover_beam: 4 },
  soil: { sigma_adm: 1.5, gamma_s: 1800, gamma_c: 2400, sigma_factor: 1.0 },
  loads: { P1: 50_000, Pu1: 75_000, P2: 70_000, Pu2: 105_000 },
  reinforcement: {
    diam_f1_x: '5/8', n_f1_x: 8,
    diam_f1_y: '5/8', n_f1_y: 8,
    diam_f2_x: '5/8', n_f2_x: 10,
    diam_f2_y: '5/8', n_f2_y: 10,
    diam_beam_top: '3/4', n_beam_top: 4,
    diam_beam_bot: '3/4', n_beam_bot: 3,
    diam_stirrup: '3/8', s_stirrup: 15,
  },
};

export const useConnectedStore = create<State>((set) => ({
  request: defaultRequest,
  setSection: (p) => set((s) => ({ request: { ...s.request, section: { ...s.request.section, ...p } } })),
  setMaterials: (p) => set((s) => ({ request: { ...s.request, materials: { ...s.request.materials, ...p } } })),
  setSoil: (p) => set((s) => ({ request: { ...s.request, soil: { ...s.request.soil, ...p } } })),
  setLoads: (p) => set((s) => ({ request: { ...s.request, loads: { ...s.request.loads, ...p } } })),
  setReinforcement: (p) => set((s) => ({ request: { ...s.request, reinforcement: { ...s.request.reinforcement, ...p } } })),
  loadRequest: (req) => set({ request: req }),
}));
